import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { TagDetailItem } from '@/entities/tags/domain/types';

type GetTagsParams = {
  parent?: string;
  limit?: number;
  fields?: string;
};

type TagsResponse = {
  data: TagDetailItem[];
  paging: {
    total: number;
    before?: string;
    after?: string;
  };
};

export const getTagsApi = async ({ parent, limit = 3000, fields = 'usageCount' }: GetTagsParams) => {
  const params: Record<string, string | number> = {
    fields,
    limit,
  };

  if (parent) {
    params.parent = parent;
  }

  const { data } = await openMetadataApiClient.get<TagsResponse>('/tags', {
    params,
  });
  return data;
};
